/* ==========================================================================
   KASE ARTIST — MOBILE V2 behaviour
   Ported from the DCLogic class in "Kase Artist Mobile v2.dc.html".

   Three behaviours, all progressive enhancement:
     1. hero carousel  the track is a native scroll-snap row, so swiping works
                       with this file absent. JS adds auto-advance and the dots
     2. FAQ            answers render open and are collapsed on init, so a
                       no-JS visitor reads all five rather than none
   The action rail is NOT here: it is permanent and pure CSS, so no script
   decides whether the store has a call to action.
   ========================================================================== */

(function () {
  'use strict';

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------- carousel -- */

  function initHero(root) {
    var track = root.querySelector('[data-kav2-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kav2-dot]'));
    if (!track) return;

    var slides = track.children.length;
    if (slides < 2) {
      dots.forEach(function (d) { d.hidden = true; });
      return;
    }

    var index = 0;
    var timer = null;
    /* The source stops auto-advance for good on first touch. Someone who has
       taken hold of the carousel does not want it moved out from under them. */
    var held = false;
    var seconds = parseFloat(root.getAttribute('data-kav2-seconds')) || 4;

    function paint() {
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function scrollToIndex(n, smooth) {
      if (!track.clientWidth) return;
      track.scrollTo({
        left: n * track.clientWidth,
        behavior: reduce || !smooth ? 'auto' : 'smooth'
      });
    }

    function start() {
      stop();
      if (reduce || held || document.hidden) return;
      timer = setInterval(function () {
        index = (index + 1) % slides;
        scrollToIndex(index, true);
        paint();
      }, Math.max(1500, seconds * 1000));
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    track.addEventListener('pointerdown', function () {
      held = true;
      stop();
    }, { passive: true });

    track.addEventListener('scroll', function () {
      if (!track.clientWidth) return;
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== index && i >= 0 && i < slides) {
        index = i;
        paint();
      }
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        held = true;
        stop();
        index = i;
        scrollToIndex(i, true);
        paint();
      });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    paint();
    start();
  }

  /* ----------------------------------------------------------- scroll cue -- */

  /* Progress readout for a sideways row: how much of it is on screen, and where
     in it the visitor currently is.

     IT READS THE ROW AND NEVER WRITES TO IT. No scrollLeft, no scrollTo, no
     scrollIntoView, nothing bound to a timer. Everything it touches is
     presentation: two custom properties and three data attributes on the cue
     element itself. Whatever the row did with a finger before this function
     existed, it still does. */
  function initCue(cue) {
    var track = cue.parentNode && cue.parentNode.querySelector('[data-kav2-cue-track]');
    if (!track) return;

    var frame = 0;

    function paint() {
      frame = 0;

      var max = track.scrollWidth - track.clientWidth;
      /* Sub-pixel rounding leaves a stray pixel or two on rows that actually
         fit, and a rail on a row nobody can move is a lie. Four blocks on a
         wide screen is exactly that case. */
      if (!track.clientWidth || max <= 2) {
        cue.hidden = true;
        return;
      }

      cue.hidden = false;
      var pos = Math.min(1, Math.max(0, track.scrollLeft / max));
      cue.style.setProperty('--kav2-cue-size', (track.clientWidth / track.scrollWidth).toFixed(4));
      cue.style.setProperty('--kav2-cue-pos', pos.toFixed(4));
      /* Not 1: the last cell snaps to `end`, and the resting scrollLeft there
         lands a fraction under the maximum often enough to matter. */
      cue.setAttribute('data-kav2-cue-end', pos > 0.985 ? 'true' : 'false');
    }

    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(paint);
    }

    track.addEventListener('scroll', function () {
      /* First movement retires the nudge for the rest of the visit. It has made
         its point by then. */
      cue.setAttribute('data-kav2-cue-moved', 'true');
      schedule();
    }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(schedule).observe(track);
    } else {
      window.addEventListener('resize', schedule);
    }

    /* Hold the nudge until the row is on screen. This section sits below the
       fold, so an animation fired at DOMContentLoaded would be over before
       anybody had scrolled down to watch it. */
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          cue.setAttribute('data-kav2-cue-seen', 'true');
          io.disconnect();
          return;
        }
      }, { threshold: 0.6 });
      io.observe(cue);
    } else {
      cue.setAttribute('data-kav2-cue-seen', 'true');
    }

    paint();
    /* Cheap insurance: the cells are sized in percentages so late images do not
       move the measurement, but a font swap or a late stylesheet can. */
    window.addEventListener('load', schedule);
  }

  /* ------------------------------------------------------------------ faq -- */

  /* The accordion is native <details name="kav2-faq">, so it opens, closes and
     stays one-at-a-time with this file absent. This only backfills the
     exclusivity for browsers that predate the name attribute on details. */
  var exclusiveDetails = 'name' in document.createElement('details');

  function initFaq(root) {
    if (exclusiveDetails) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('details.kav2-q'));

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  /* ------------------------------------------------- brand first finder --- */

  /* Series are derived here rather than in Liquid: Liquid has no regex, so doing
     it there means a ladder of `contains` per product per render. The browser
     already holds every title and can do it once. */
  function seriesOf(m) {
    var t = m.n.toLowerCase();
    if (m.b === 'Samsung') {
      if (t.indexOf('fold') > -1) return 'Fold';
      if (t.indexOf('flip') > -1) return 'Flip';
      if (t.indexOf('note') > -1) return 'Note';
      var s = t.match(/\b([asfmz])\s?\d/);
      if (s) return s[1].toUpperCase() + '-Series';
      return 'Other';
    }
    if (m.b === 'Apple') {
      var g = t.match(/iphone\s?(\d{1,2})/);
      if (g) return 'iPhone ' + g[1];
      if (t.indexOf('se') > -1) return 'iPhone SE';
      return 'iPhone X';
    }
    return 'All';
  }

  /* Sort a series list newest first for Apple (17 before 11) and by the order
     people actually shop for Samsung, with the volume series first. */
  var SAMSUNG_ORDER = ['S-Series', 'A-Series', 'Z-Series', 'Fold', 'Flip', 'Note', 'M-Series', 'F-Series', 'Other'];
  function sortSeries(brand, list) {
    if (brand === 'Apple') {
      return list.sort(function (a, b) {
        var na = seriesGen(a);
        var nb = seriesGen(b);
        if (isNaN(na)) return 1;
        if (isNaN(nb)) return -1;
        return nb - na;
      });
    }
    return list.sort(function (a, b) {
      var ia = SAMSUNG_ORDER.indexOf(a), ib = SAMSUNG_ORDER.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
  }

  /* ------------------------------------------------------ model ordering -- */

  /* The list is ordered the way a person scans for their own phone: newest
     generation first, and within a generation the top trim first.

       iPhone 17 Pro Max . 17 Pro . 17 Plus . 17
       Galaxy S26 Ultra  . S26 Plus . S26

     This replaces sales rank as the primary key. Rank was commercially honest
     and read as random: iPhone 13 sitting above iPhone 17 is correct by units
     and looks broken to someone hunting for a model. Rank is gone; the tie
     break is the name.

     Generation is only comparable INSIDE a series. Galaxy A56 and Galaxy S26
     are both "5x/2x" numbers from unrelated ladders, so series rank is always
     the first key and the raw number never competes across ladders. */

  function seriesGen(s) {
    if (s === 'iPhone X') return 10;              /* X is the 10, so it slots
                                                     between 11 and 8 */
    var n = parseInt(String(s).replace(/\D/g, ''), 10);
    return isNaN(n) ? NaN : n;
  }

  function seriesRank(m) {
    if (m.b === 'Samsung') {
      var i = SAMSUNG_ORDER.indexOf(m._s);
      return i < 0 ? 99 : i;
    }
    var n = seriesGen(m._s);
    return isNaN(n) ? 99 : 100 - n;               /* newest series lowest */
  }

  /* Generation number. Read after the series marker for the folding lines,
     because "Galaxy Z Flip 6" has its number at the end rather than welded to
     a letter the way "S24" does. */
  function genOf(m) {
    var t = m.n.toLowerCase();
    if (m.b === 'Apple') {
      var g = t.match(/iphone\s*(\d{1,2})/);
      if (g) return parseInt(g[1], 10);
      return t.indexOf('x') > -1 ? 10 : 0;
    }
    var fold = t.match(/(?:fold|flip|note)\s*(\d{1,2})/);
    if (fold) return parseInt(fold[1], 10);
    var ser = t.match(/\b[asfmz]\s?(\d{1,3})/);
    if (ser) return parseInt(ser[1], 10);
    var any = t.match(/(\d{1,3})/);
    return any ? parseInt(any[1], 10) : 0;
  }

  /* Trim, best first. Ultra and Pro Max are both the top of their own ladder so
     they share a rank; no model carries one of each. */
  function tierOf(m) {
    var t = m.n.toLowerCase();
    if (/pro\s*max/.test(t)) return 0;
    if (/ultra/.test(t)) return 0;
    if (/\bpro\b/.test(t)) return 1;
    if (/\bmax\b/.test(t)) return 1;               /* XS Max, no "pro" */
    if (/plus|\+/.test(t)) return 2;
    if (/\bair\b/.test(t)) return 3;
    if (/\bfe\b/.test(t)) return 5;
    if (/mini/.test(t)) return 6;
    if (/\d\s*e\b/.test(t)) return 7;              /* 16E */
    return 4;                                      /* the plain one */
  }

  function byNewest(a, b) {
    var sa = seriesRank(a), sb = seriesRank(b);
    if (sa !== sb) return sa - sb;
    if (a._g !== b._g) return b._g - a._g;
    if (a._t !== b._t) return a._t - b._t;
    return a.n.localeCompare(b.n, undefined, { numeric: true });
  }

  /* -------------------------------------------------------- device art -- */

  /* Two things identify a phone at thumbnail size: the CAMERA LAYOUT and the
     BODY SIZE. Both are facts about the handset, so both can be drawn
     correctly. Colour cannot: people buy whatever colour was in stock, so a
     colour render says nothing about whether it is their phone.

     These schematics are the shipping default and the fallback. A model can
     override them with a real photograph by carrying "i" (an image URL) in the
     index, which ka-model-data fills from the `device.image` metafield. Nothing
     here changes when that happens: set the metafield, the photo wins.

     They are OUR drawings of a rectangle and some circles, which is why they
     can ship. They are not traced from anyone's press assets. */

  /* Each archetype owns its BODY as well as its camera, because a Fold is not
     a slab with different lenses and drawing it as one is a lie the customer
     pays for. w/h are the viewBox; art is everything on top of the body. */
  var SLAB = [91, 192];

  var ARCH = {
    /* square plateau, three lenses in a triangle: iPhone Pro, 11 through 16 */
    proTriple: { vb: SLAB, art:
      '<rect x="9" y="7" width="47" height="47" rx="14" class="d-plate"/>' +
      '<circle cx="23" cy="21" r="7.3" class="d-lens"/>' +
      '<circle cx="23" cy="41" r="7.3" class="d-lens"/>' +
      '<circle cx="42" cy="41" r="7.3" class="d-lens"/>' +
      '<circle cx="43" cy="20" r="3.2" class="d-flash"/>' },
    /* square plateau, two lenses on the diagonal: 11 to 15 non Pro */
    dualDiag: { vb: SLAB, art:
      '<rect x="9" y="7" width="43" height="43" rx="13" class="d-plate"/>' +
      '<circle cx="22" cy="20" r="8.2" class="d-lens"/>' +
      '<circle cx="39" cy="37" r="8.2" class="d-lens"/>' },
    /* square plateau, two side by side: iPhone 7 Plus and 8 Plus */
    dualHoriz: { vb: SLAB, art:
      '<rect x="9" y="7" width="45" height="26" rx="12" class="d-plate"/>' +
      '<circle cx="21" cy="20" r="8" class="d-lens"/>' +
      '<circle cx="42" cy="20" r="8" class="d-lens"/>' },
    /* vertical pill, two stacked: iPhone 16 and 17 */
    dualPill: { vb: SLAB, art:
      '<rect x="10" y="7" width="21" height="43" rx="10.5" class="d-plate"/>' +
      '<circle cx="20.5" cy="18" r="7" class="d-lens"/>' +
      '<circle cx="20.5" cy="39" r="7" class="d-lens"/>' },
    /* horizontal plateau, three in a row: iPhone 17 Pro */
    barTriple: { vb: SLAB, art:
      '<rect x="8" y="7" width="75" height="27" rx="9" class="d-plate"/>' +
      '<circle cx="21" cy="20.5" r="8" class="d-lens"/>' +
      '<circle cx="43" cy="20.5" r="8" class="d-lens"/>' +
      '<circle cx="65" cy="20.5" r="8" class="d-lens"/>' },
    /* horizontal plateau, one lens: iPhone 17 Air */
    barSingle: { vb: SLAB, art:
      '<rect x="8" y="7" width="75" height="27" rx="9" class="d-plate"/>' +
      '<circle cx="21" cy="20.5" r="8" class="d-lens"/>' },
    /* square plateau, two stacked: iPhone X, XS, XS Max */
    dualVert: { vb: SLAB, art:
      '<rect x="9" y="7" width="26" height="45" rx="12" class="d-plate"/>' +
      '<circle cx="22" cy="19" r="8" class="d-lens"/>' +
      '<circle cx="22" cy="40" r="8" class="d-lens"/>' },
    /* one lens: iPhone 6 Plus, 16e, entry Galaxy */
    single: { vb: SLAB, art:
      '<circle cx="22" cy="20" r="8.6" class="d-lens"/>' },
    /* two bare lenses: entry Galaxy A */
    dualBare: { vb: SLAB, art:
      '<circle cx="21" cy="17" r="7.4" class="d-lens"/>' +
      '<circle cx="21" cy="35" r="7.4" class="d-lens"/>' },
    /* three bare lenses, no housing: Galaxy S22 onward */
    galaxyTriple: { vb: SLAB, art:
      '<circle cx="21" cy="16" r="7.4" class="d-lens"/>' +
      '<circle cx="21" cy="34" r="7.4" class="d-lens"/>' +
      '<circle cx="21" cy="52" r="7.4" class="d-lens"/>' },
    /* four bare lenses: Galaxy S Ultra */
    galaxyQuad: { vb: SLAB, art:
      '<circle cx="21" cy="14" r="7.2" class="d-lens"/>' +
      '<circle cx="21" cy="31" r="7.2" class="d-lens"/>' +
      '<circle cx="21" cy="48" r="7.2" class="d-lens"/>' +
      '<circle cx="40" cy="14" r="4.4" class="d-flash"/>' },
    /* rounded housing with three: Galaxy A mid, Note, older S */
    housingTriple: { vb: SLAB, art:
      '<rect x="9" y="7" width="34" height="49" rx="12" class="d-plate"/>' +
      '<circle cx="26" cy="20" r="7" class="d-lens"/>' +
      '<circle cx="26" cy="37" r="7" class="d-lens"/>' +
      '<circle cx="26" cy="50" r="4.4" class="d-lens"/>' },

    /* FOLDED book. Narrower and thicker than a slab, with the hinge showing
       down one edge. This is the shape the case actually wraps. */
    fold: { vb: [84, 176], r: 7, art:
      '<line x1="17" y1="6" x2="17" y2="170" class="d-hinge"/>' +
      '<circle cx="49" cy="20" r="6.6" class="d-lens"/>' +
      '<circle cx="49" cy="37" r="6.6" class="d-lens"/>' +
      '<circle cx="49" cy="54" r="6.6" class="d-lens"/>' },

    /* FOLDED clamshell. Close to square, with the crease across the middle and
       the cover screen above it. Nothing like a slab, and it must not read as
       one. */
    flip: { vb: [91, 104], r: 12, art:
      '<line x1="3" y1="52" x2="88" y2="52" class="d-hinge"/>' +
      '<rect x="40" y="10" width="42" height="30" rx="8" class="d-plate"/>' +
      '<circle cx="17" cy="18" r="7.4" class="d-lens"/>' +
      '<circle cx="17" cy="36" r="7.4" class="d-lens"/>' }
  };

  /* Camera layout, by model. Ordered most specific first: "17 pro" has to be
     tested before "17", and "pro max" before "pro". */
  function archOf(m) {
    var t = m.n.toLowerCase();

    if (m.b === 'Apple') {
      var g = m._g;
      if (g === 17) {
        if (/air/.test(t)) return 'barSingle';
        if (/pro/.test(t)) return 'barTriple';
        return 'dualPill';
      }
      if (g === 16) {
        if (/\d\s*e\b/.test(t)) return 'single';    /* 16e is one lens */
        if (/pro/.test(t)) return 'proTriple';
        return 'dualPill';
      }
      if (g >= 11 && g <= 15) return /pro/.test(t) ? 'proTriple' : 'dualDiag';
      if (g === 10) return 'dualVert';              /* X, XS, XS Max */
      if (g === 7 || g === 8) {
        return /plus/.test(t) ? 'dualHoriz' : 'single';
      }
      return 'single';                              /* 6 and 6s era */
    }

    if (m.b === 'Samsung') {
      /* form first: a folding phone is a different object, not a lens variant */
      if (/fold/.test(t)) return 'fold';
      if (/flip/.test(t)) return 'flip';

      if (/ultra/.test(t) && m._g >= 22) return 'galaxyQuad';
      if (m._s === 'S-Series' && m._g >= 22) return 'galaxyTriple';

      /* Entry A-series carry two lenses or one, not three. A0x and the older
         two digit A1x/A2x sit here; A3x and up get the triple housing. */
      if (m._s === 'A-Series') {
        var num = t.match(/\ba0?(\d{1,2})/);
        var tier = num ? parseInt(num[1], 10) : 99;
        if (tier <= 7) return 'dualBare';
        return 'housingTriple';
      }
      return 'housingTriple';
    }
    return 'dualDiag';
  }

  /* Body size, as a fraction of the well. A Pro Max really is bigger than a
     Pro, so the drawing says so. "XS Max" and "Note 10 Plus" have to land here
     too: matching only "pro max" drew an XS Max the size of an XS. */
  function sizeOf(m) {
    var t = m.n.toLowerCase();
    if (/\bmax\b|ultra/.test(t)) return 1.0;
    if (/plus|\+/.test(t)) return 0.97;
    if (/air/.test(t)) return 0.93;
    if (/mini/.test(t)) return 0.80;
    return 0.89;
  }

  /* The schematic. The viewBox is the body itself, so camera art is authored
     once per archetype against that archetype's own coordinate space. */
  function deviceSvg(m) {
    var a = ARCH[archOf(m)];
    var w = a.vb[0], h = a.vb[1], r = a.r || 13;
    return '<svg class="kav2-dev" viewBox="0 0 ' + w + ' ' + h + '"' +
      ' style="height:' + (sizeOf(m) * 100) + '%"' +
      ' aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet">' +
      '<rect x="1" y="1" width="' + (w - 2) + '" height="' + (h - 2) + '" rx="' + r +
      '" class="d-body"/>' + a.art +
      '</svg>';
  }

  /* --------------------------------------------------------- case types -- */

  /* The back of the case, drawn the way the real product is built: a moulded
     frame, a camera window at the top, and the printed panel BELOW it. The
     print does not wrap the sides, so the art must not either.

     Mag adds the magnet ring on the panel. That ring is the entire difference
     between a R299 case and a R499 one, so it is worth drawing rather than
     describing twice.

     The OUTLINE is the chosen model's own body, borrowed from the device
     schematics above. Same reason a Fold is not drawn as a slab in the model
     grid: a case for a folding phone is a different object, and by this step
     the shopper has told us which one they own. Everything inside is placed as
     a fraction of that box, so one set of numbers serves a slab, a book and a
     clamshell. */
  function caseSvg(m, isMag) {
    var a = ARCH[archOf(m)];
    var w = a.vb[0], h = a.vb[1], r = a.r || 13;

    function box(x1, y1, x2, y2, rx, cls) {
      return '<rect x="' + (w * x1) + '" y="' + (h * y1) +
        '" width="' + (w * (x2 - x1)) + '" height="' + (h * (y2 - y1)) +
        '" rx="' + rx + '" class="' + cls + '"/>';
    }

    var ring = '';
    if (isMag) {
      var cx = w * 0.5, cy = h * 0.64, rad = Math.min(w * 0.29, h * 0.14);
      ring =
        '<circle cx="' + cx + '" cy="' + cy + '" r="' + rad + '" class="c-ring"/>' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="' + (rad * 0.5) + '" class="c-ring"/>';
    }

    return '<svg class="kav2-case__art" viewBox="0 0 ' + w + ' ' + h + '"' +
      ' aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet">' +
      '<rect x="1" y="1" width="' + (w - 2) + '" height="' + (h - 2) + '" rx="' + r +
      '" class="c-body"/>' +
      box(0.10, 0.04, 0.62, 0.26, r * 0.55, 'c-window') +
      box(0.10, 0.33, 0.90, 0.95, r * 0.45, 'c-panel') +
      ring +
      '</svg>';
  }

  /* Matched on the NAME rather than on a fixed list of two values. "PrintGuard"
     and "PrintGuard Mag" are David's names and have already changed once, from
     Slim and MagSafe; a few products in the catalogue are still on the older
     ones. Testing for "mag" survives a rename to PrintGuard MagSafe or
     PrintGuard Mag Clear, and anything unrecognised simply renders with no
     supporting line rather than with the wrong one. */
  function isMagType(title) {
    return /\bmag/i.test(String(title || ''));
  }

  function initFinder(root) {
    var dataEl = document.getElementById('ka-model-data');
    if (!dataEl) return;

    var models;
    try { models = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!models.length) return;

    var q = root.querySelector('[data-kav2-q]');
    var clear = root.querySelector('[data-kav2-clear]');
    var steps = {
      brand: root.querySelector('[data-kav2-step="brand"]'),
      model: root.querySelector('[data-kav2-step="model"]'),
      results: root.querySelector('[data-kav2-step="results"]'),
      'case': root.querySelector('[data-kav2-step="case"]')
    };
    var grid = root.querySelector('[data-kav2-models]');
    var resultGrid = root.querySelector('[data-kav2-results]');
    var resultCount = root.querySelector('[data-kav2-result-count]');
    var empty = root.querySelector('[data-kav2-empty]');
    var brandLabel = root.querySelector('[data-kav2-current-brand]');
    var caseGrid = root.querySelector('[data-kav2-cases]');
    var caseFor = root.querySelector('[data-kav2-case-for]');
    var caseBack = root.querySelector('[data-kav2-case-back]');

    var brand = null;
    var at = 'brand';        /* the step on screen */
    var caseReturn = 'brand'; /* where Back goes from the case step */

    models.forEach(function (m) {
      m._s = seriesOf(m);
      m._g = genOf(m);
      m._t = tierOf(m);
      /* Cheapest first, always. Shopify hands variants back in their admin
         position, which on iPhone 13 Pro puts PrintGuard Mag first: leading a
         R299 shopper with R499 reads as a price rise rather than as an option.
         Sorted here once rather than at every render. */
      m._v = (m.v || []).slice().sort(function (a, b) { return a.c - b.c; });
    });

    root.querySelectorAll('[data-kav2-brand-count]').forEach(function (el) {
      var b = el.getAttribute('data-kav2-brand-count');
      var n = models.filter(function (m) { return m.b === b; }).length;
      el.textContent = n + ' models';
    });

    function show(which) {
      Object.keys(steps).forEach(function (k) {
        if (steps[k]) steps[k].hidden = k !== which;
      });
      at = which;
      /* The search field asks "which phone", so it has no business sitting
         above "which case". Leaving it there makes the model choice look like
         it did not register. */
      root.classList.toggle('is-choosing-case', which === 'case');
    }

    function href(m, v) {
      /* ?variant= is what carries the answer. product.liquid reads it through
         selected_or_first_available_variant, so the radio arrives checked, the
         price is right, and the ColorPark block is built against that variant
         rather than against whichever one happened to render first. */
      return '/products/' + m.h + (v ? '?variant=' + v.id : '');
    }

    function report(name, props) {
      /* ka.js owns the reporting fan-out. Read at call time, never captured:
         both files are deferred and nothing here should depend on which one
         the browser finished parsing first. */
      try { if (window.kaTrack) window.kaTrack(name, props || {}); } catch (e) {}
    }

    function tile(m) {
      var a = document.createElement('a');
      var many = m._v.length > 1;
      a.className = 'kav2-model' + (m.a ? '' : ' kav2-model--oos');

      /* The href is a real product URL either way, so middle click, long press
         and "open in new tab" all still do the obvious thing, and a model with
         one case type carries that variant explicitly. The case step is an
         interception of the ordinary left click, not a replacement for the
         link. */
      a.href = href(m, many ? null : m._v[0]);

      /* A licensed photograph wins when one exists; the schematic is the
         default. lazy + async decode because a full brand is 55 wells and none
         of them are above the fold on a phone. */
      var art = m.i
        ? '<img class="kav2-dev-img" src="' + m.i + '" alt="" loading="lazy" decoding="async">'
        : deviceSvg(m);

      /* "From R299" rather than "R299" wherever the model has a second, dearer
         case type, because the tile price is then a floor and not the price. */
      var price = many ? 'From ' + m._v[0].p : m.p;

      a.innerHTML =
        '<span class="kav2-model__well">' + art + '</span>' +
        '<span class="kav2-model__name">' + m.n + '</span>' +
        '<span class="kav2-model__meta">' + (m.a ? price : 'Back soon') + '</span>';

      if (many) {
        a.addEventListener('click', function (e) {
          /* Anything that is not a plain left click is someone asking for the
             product page in their own way. Let them have it. */
          if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          openCase(m);
        });
      }
      return a;
    }

    /* ------------------------------------------------------- which case -- */

    function caseCard(m, v) {
      var a = document.createElement('a');
      var mag = isMagType(v.t);
      a.className = 'kav2-case' + (v.a ? '' : ' kav2-case--oos');
      a.href = href(m, v);

      var note = caseGrid.getAttribute(mag ? 'data-note-mag' : 'data-note-base') || '';

      /* Name and price on ONE line, note beneath both. The price is what the
         two cards are compared on, so it has to sit on the name's line rather
         than float somewhere above it: the well is 76px tall and the text
         block is not, so a price in its own column lands level with nothing. */
      a.innerHTML =
        '<span class="kav2-case__well">' + caseSvg(m, mag) + '</span>' +
        '<span class="kav2-case__text">' +
          '<span class="kav2-case__head">' +
            '<span class="kav2-case__name">' + v.t + '</span>' +
            '<span class="kav2-case__price">' + (v.a ? v.p : 'Back soon') + '</span>' +
          '</span>' +
          (note ? '<span class="kav2-case__note">' + note + '</span>' : '') +
        '</span>';

      a.addEventListener('click', function () {
        report('ka_case_selected', { model: m.n, handle: m.h, case_type: v.t, variant_id: v.id });
      });
      return a;
    }

    function openCase(m) {
      caseReturn = at;
      caseFor.textContent = m.n;

      caseGrid.textContent = '';
      var frag = document.createDocumentFragment();
      m._v.forEach(function (v) { frag.appendChild(caseCard(m, v)); });
      caseGrid.appendChild(frag);

      show('case');

      /* The finder can be a long way down /pages/phone-models, and the model
         just tapped can be the last one in the grid. Swapping the content
         under a viewport that stays put is how a step gets missed entirely. */
      try { root.scrollIntoView({ block: 'start' }); } catch (e) { root.scrollIntoView(); }

      /* Nothing between landing and purchase is currently measured, so the two
         events the funnel is missing are the ones this step creates. */
      report('ka_case_step', {
        model: m.n,
        handle: m.h,
        case_types: m._v.map(function (v) { return v.t; }).join(',')
      });
    }

    if (caseBack) {
      caseBack.addEventListener('click', function () {
        show(caseReturn === 'case' ? 'brand' : caseReturn);
      });
    }

    function paint(target, list) {
      target.textContent = '';
      target.classList.remove('kav2-models--grouped');
      var frag = document.createDocumentFragment();
      list.forEach(function (m) { frag.appendChild(tile(m)); });
      target.appendChild(frag);
    }

    /* Grouped render: a heading per series, then that series' models. This is
       the ONLY browse view now. It used to share the job with a row of series
       chips above it, which restated the same headings as buttons and then
       hid every group but one. The headings are the breakdown; scrolling past
       a group you do not want is cheaper than filtering to the one you do. */
    function paintGrouped(target, list) {
      target.textContent = '';
      /* the target IS the grid, so grouping has to turn it back into a plain
         block or every group becomes a grid inside a grid */
      target.classList.add('kav2-models--grouped');
      var frag = document.createDocumentFragment();

      var order = sortSeries(brand, list.map(function (m) { return m._s; })
        .filter(function (s, i, arr) { return arr.indexOf(s) === i; }));

      order.forEach(function (s) {
        var group = list.filter(function (m) { return m._s === s; }).sort(byNewest);
        if (!group.length) return;

        var h = document.createElement('h3');
        h.className = 'kav2-group';
        h.textContent = s;
        frag.appendChild(h);

        var g = document.createElement('div');
        g.className = 'kav2-models';
        group.forEach(function (m) { g.appendChild(tile(m)); });
        frag.appendChild(g);
      });

      target.appendChild(frag);
    }

    function renderBrand() {
      var list = models.filter(function (m) { return m.b === brand; });
      paintGrouped(grid, list);
      brandLabel.textContent = brand + ' . ' + list.length + ' models';
      show('model');
    }

    root.querySelectorAll('[data-kav2-brand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        brand = btn.getAttribute('data-kav2-brand');
        renderBrand();
      });
    });

    var back = root.querySelector('[data-kav2-back]');
    if (back) {
      back.addEventListener('click', function () {
        brand = null;
        show('brand');
      });
    }

    function search() {
      var term = q.value.trim().toLowerCase();
      clear.hidden = !term;

      if (!term) {
        show(brand ? 'model' : 'brand');
        return;
      }

      var hits = models.filter(function (m) {
        return (m.n + ' ' + m.b).toLowerCase().indexOf(term) > -1;
      }).sort(byNewest);

      paint(resultGrid, hits);
      resultCount.textContent = hits.length
        ? hits.length + (hits.length === 1 ? ' model matches.' : ' models match.')
        : '';
      empty.hidden = hits.length > 0;
      show('results');
    }

    q.addEventListener('input', search);
    clear.addEventListener('click', function () {
      q.value = '';
      search();
      q.focus();
    });

    show('brand');
  }

  /* ----------------------------------------------- sheet scroll lock fix -- */

  /* ka.js locks the page while the finder sheet is open by setting
     `documentElement.style.overflow = 'hidden'` inline, and only its own close
     button clears it. That leaves one very ordinary path broken:

       open the sheet -> tap a model -> product page -> browser Back

     Back restores the homepage from bfcache with that inline style still on the
     element, so the page will not scroll and nothing on screen explains why.

     `pageshow` fires on a bfcache restore where `load` does not, so it is the
     only reliable hook. The sheet is closed as well as unlocked, because coming
     back to a page with a search sheet still sitting open is its own confusion. */
  function initScrollLockRecovery() {
    var sheet = document.getElementById('ka-finder-sheet');
    var de = document.documentElement;

    function recover() {
      if (sheet && sheet.classList.contains('is-open')) {
        sheet.classList.remove('is-open');
        sheet.setAttribute('aria-hidden', 'true');
      }
      if (de.style.overflow === 'hidden') de.style.overflow = '';
    }

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) recover();
    });

    /* Anything that leaves the page locked with no sheet on screen is a bug we
       have not found yet. Clear it rather than trap the visitor. */
    if (!sheet || !sheet.classList.contains('is-open')) {
      if (de.style.overflow === 'hidden') de.style.overflow = '';
    }

    /* A sheet marked open that CANNOT be displayed still locks the page, and
       .is-open is set, so the check above lets it through. Two ways in: an
       older build's desktop click, and resizing past 990px with the sheet
       open. Either way the visitor is left on a page that will not scroll. */
    function unlockIfSheetInvisible() {
      if (!sheet) return;
      if (!sheet.classList.contains('is-open')) return;
      if (getComputedStyle(sheet).display !== 'none') return;
      recover();
    }
    unlockIfSheetInvisible();
    window.addEventListener('resize', unlockIfSheetInvisible);
  }

  /* --------------------------------------------------- finder sheet guard -- */

  /* The sticky bar and the hero CTA both carry data-ka-open-finder, and ka.js
     binds that to preventDefault() plus open the sheet. The sheet is only
     useful where #ka-model-data is on the page, which is the homepage. The bar
     is on every page, so everywhere else that binding turns a working link into
     a dead end that opens an empty search.

     Caught in the capture phase because ka.js is deferred ahead of this file
     and has already bound its bubble-phase handler. Stopping propagation here
     leaves the default action intact, so the link simply navigates. */
  /* The sheet is usable only when it exists, has an index to search, AND can
     actually be painted. ka.css hides it outright from 990px up:

       @media (min-width: 990px) { .ka-sheet { display: none; } }

     ka.js does not check that. openSheet() adds .is-open and sets
     documentElement.style.overflow = 'hidden' whatever the width, so on a
     desktop the hero CTA preventDefaults, locks the page, and then shows
     nothing at all. The page stops scrolling with no visible cause and only
     Escape or a reload clears it. That is the "Find your phone freezes the
     site" bug, and it fires on every desktop click. */
  function sheetUsable() {
    var s = document.getElementById('ka-finder-sheet');
    if (!s) return false;
    if (!document.getElementById('ka-model-data')) return false;
    return getComputedStyle(s).display !== 'none';
  }

  function guardFinderTriggers() {
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target.closest && e.target.closest('[data-ka-open-finder]');
        if (!t) return;
        if (sheetUsable()) return;

        /* Capture phase, ahead of ka.js's bubble handler. Stopping propagation
           leaves the default action intact, so an anchor simply navigates. */
        e.stopPropagation();

        var href = t.tagName === 'A' && t.getAttribute('href');
        if (!href || href === '#') {
          /* a <button>, or an anchor with nothing to go to: send it to the
             full picker rather than let the click do nothing at all */
          e.preventDefault();
          window.location.href = '/pages/phone-models';
        }
      },
      true
    );
  }

  /* ------------------------------------------------------- the model wall -- */

  /* /pages/phone-models ships every model as a server rendered grid per brand.
     That wall is the crawlable index and it is the cheapest defence we have of
     organic search, which is 62% of traffic and falling. It also means a
     visitor who has just been asked to pick a brand is looking at all 84
     models at once, which makes the question pointless.

     So the wall stays in the HTML and JAVASCRIPT hides it. That ordering is the
     whole point: no JS, nothing hidden, crawler sees the full index exactly as
     before. With JS the page asks the question properly, and the finder above
     answers it grouped and in order.

     Not display:none on the server, and not JS rendered. Both of those break
     the index. */
  function initModelWall() {
    var walls = document.querySelectorAll('[data-kav2-wall]');
    if (!walls.length) return;

    /* Only hide it when the finder is actually on the page to replace it.
       Hiding the wall on a page with no picker would leave a visitor with
       nothing at all. */
    var finder = document.querySelector('[data-kav2-finder]');
    if (!finder || !document.getElementById('ka-model-data')) return;

    /* Hidden for good, not toggled. The finder's own step 2 already renders the
       chosen brand grouped by series and in order, so revealing the wall as
       well would put the same 29 models on the screen twice. The wall's job on
       a JS page is done the moment the HTML is served. */
    walls.forEach(function (w) { w.hidden = true; });
  }

  /* ----------------------------------------------------------------- boot -- */

  /* Every step is isolated. One section throwing on real catalogue data that no
     local harness reproduces must never take the rest of the page's behaviour
     with it, which is exactly how the action rail died silently once. */
  function boot() {
    var steps = [
      ['scrollLock', initScrollLockRecovery],
      ['finderGuard', guardFinderTriggers],
      ['hero', function () { document.querySelectorAll('[data-kav2-hero]').forEach(initHero); }],
      ['cue', function () { document.querySelectorAll('[data-kav2-cue]').forEach(initCue); }],
      ['faq', function () { document.querySelectorAll('[data-kav2-faq]').forEach(initFaq); }],
      ['finder', function () { document.querySelectorAll('[data-kav2-finder]').forEach(initFinder); }],
      ['wall', initModelWall]
    ];
    for (var i = 0; i < steps.length; i++) {
      try {
        steps[i][1]();
      } catch (e) {
        if (window.console && console.error) {
          console.error('ka-v2: ' + steps[i][0] + ' failed', e);
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: sections are re-rendered without a page load. The action rail
     needs nothing here, because it is pure CSS now and has no state to rebuild. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-kav2-hero]').forEach(initHero);
    e.target.querySelectorAll('[data-kav2-cue]').forEach(initCue);
    e.target.querySelectorAll('[data-kav2-faq]').forEach(initFaq);
  });
})();
